import { useEffect, useRef, type ReactNode } from "react";

type Props = {
  aberto: boolean;
  titulo: string;
  onFechar: () => void;
  children: ReactNode;
};

/** Modal acessível sobre o <dialog> nativo (Esc fecha, foco fica preso dentro). */
export function Modal({ aberto, titulo, onFechar, children }: Props) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialogo = ref.current;
    if (!dialogo) return;
    if (aberto && !dialogo.open) dialogo.showModal();
    if (!aberto && dialogo.open) dialogo.close();
  }, [aberto]);

  return (
    <dialog
      ref={ref}
      className="modal"
      aria-label={titulo}
      onCancel={(e) => {
        e.preventDefault();
        onFechar();
      }}
    >
      {aberto && (
        <>
          <div className="modal-cab">
            <h3>{titulo}</h3>
            <button type="button" className="fechar" onClick={onFechar} aria-label="Fechar">
              ×
            </button>
          </div>
          <div className="modal-corpo">{children}</div>
        </>
      )}
    </dialog>
  );
}
